import { TThunkAction } from '../../types/redux';
import {
  fetchGetStatusAboutCreatedMessageChatMessage,
  IGetStatusAboutCreatedMessageChatMessageResponse,
  IGetStatusAboutCreatedMessageChatMessageResponse200,
  IGetStatusAboutCreatedMessageChatMessageResponse400,
} from '../../repositories/demand/v1/get-status-about-created-message-chat-message';
import { setChatId } from '../../slices';

export const getStatusAboutChatMessage =
  (): TThunkAction<Promise<IGetStatusAboutCreatedMessageChatMessageResponse | {}>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();
    const { formSubmitData } = state;
    const parameters = { messageId: formSubmitData.messageId as number };

    try {
      const getStatusAboutChatMessage = await fetchGetStatusAboutCreatedMessageChatMessage<
        IGetStatusAboutCreatedMessageChatMessageResponse200,
        IGetStatusAboutCreatedMessageChatMessageResponse400
      >({ httpApi, parameters });

      if (getStatusAboutChatMessage.statusCode === 200) {
        const { chatId, status } = getStatusAboutChatMessage.response;

        dispatch(setChatId({ status, chatId }));

        return getStatusAboutChatMessage.response;
      }

      throw getStatusAboutChatMessage.response;
    } catch (error) {
      logger.error(error, {
        messageId: formSubmitData.messageId,
        errorMessage:
          'Ошибка при получении статуса чата (ручка /public/v1/get-status-about-created-message-chat-message/)',
        domain: 'getStatusAboutChatMessage.test.ts',
      });

      return {};
    }
  };
